import { Breadcrumb } from '@/components/general/BreadCrumb';
import SectionHead from '@/components/general/SectionHead';
import React from 'react';
import styles from './styles.module.css';
// import BlogSearch from '../BlogSearch';
import { setState, Tags } from '@/commonTypes';
import BlogSearch from '@/components/pages/blog/blogsContent/BlogSearch';
import AppLink from '@/components/common/AppLink';
import { useTranslations } from 'next-intl';

export default function SearchHero({
  setPageNumber,
  tags,
  searchKey = 'q',
}: {
  setPageNumber: setState<number | string>;
  tags?: Tags[];
  searchKey?: string;
}) {
  const tCommon = useTranslations('common');

  return (
    <>
      <Breadcrumb items={[{ label: 'خانه', to: '/' }, { label: 'نتایج جستجو' }]} />
      <SectionHead
        title={'جستجو در همهٔ بخش‌های کارا'}
        text={'خدمات، کالاها، فروشگاه‌ها، برندها و مقالات — همه در یک نتیجه.'}
        headingTag="h1"
        type="otherPages"
        // titleClass={`${styles.titleClass}`}
      />

      <BlogSearch searchKey={searchKey} />
      {tags?.length != 0 && (
        <div className={`${styles.hero_tags}`}>
          <span className={`${styles.label}`}>{tCommon('mostSearched')}:</span>
          {tags?.map((item, index) => (
            <AppLink key={index} href={`/search?${searchKey}=${item?.title}`}>
              <div className={`${styles.tag}`}>{item?.title}</div>
            </AppLink>
          ))}
        </div>
      )}
    </>
  );
}
